import {
    ActivityReadDTO,
    EquipmentReadDTO,
    ListOfValuesReadDTO,
    LocationDTO,
    LockoutReadDTO,
    LockoutUpdateDTO,
} from '../../../api/dto';

export const mapLockoutToUpdateDTO = (lockout: any, isCreation: boolean = false): LockoutUpdateDTO & LockoutReadDTO => {
    const { activity, ...lockoutWithoutActivity } = lockout as any;
    return isCreation ? lockout : lockoutWithoutActivity;
};

export const makeLockoutValues = (lockoutReadDTO: LockoutReadDTO): LockoutReadDTO => {
    return {
        ...lockoutReadDTO,
        // TODO revisit this method
    };
};

export const makeLockoutDefaultValuesFromLinkedActivity = (
    linkedActivity: ActivityReadDTO,
    lockoutType: ListOfValuesReadDTO
) => {
    return {
        activity: linkedActivity,
        lockoutLocations:
            linkedActivity?.locations
                ?.map(({ location }) => location)
                .filter((location): location is LocationDTO => location !== null) ?? [],
        availableActions: {
            attachable: false,
            canClone: false,
        },
        equipmentWorkedOn: linkedActivity?.espQuestions?.equipmentWorkedOn?.map(
            (equipment) => ({ code: equipment.code, description: equipment.description } as EquipmentReadDTO)
        ),
        equipmentWorkedOnText: linkedActivity?.espQuestions?.equipmentWorkedOnText ?? null,
        requestStartDate: linkedActivity?.espQuestions?.lockoutRequestStartDate ?? null,
        requestEndDate: linkedActivity?.espQuestions?.lockoutRequestEndDate ?? null,
        lockoutType,
    } satisfies Partial<LockoutReadDTO>;
};

export const makeLockoutDefaultValuesFromClonedLockout = (lockoutReadDTO: LockoutReadDTO) => {
    const { id, version, ...rest } = lockoutReadDTO;
    return {
        ...rest,
        equipmentToLock: [],
        powerConvertersText: null,
        lockout1level: null,
        lockout2level: null,
        grantedWorkingTime: null,
        grantedWorkingTimeStart: null,
        grantedWorkingTimeEnd: null,
        lockExecutionDate: null,
        lockEdmsProcedure: null,
        lockOtherProcedure: null,
        lockoutComments: null,
        unlockExecutionDate: null,
        unlockEdmsProcedure: null,
        unlockOtherProcedure: null,
        unlockExecutionComments: null,
        lockType: null,
        full: null,
        availableActions: {
            attachable: false,
            canClone: false,
        },
    } satisfies Omit<LockoutReadDTO, 'id' | 'version'>;
};
